import {
  clearNotifications,
  showError,
  showInfo
} from "./../../../../notifications/ducks/actions";
import getApiClient from "./../../../../shared/api";
import { connection } from "../../../../middleware/filmTaskSignalRMiddleware";
import { HubConnectionState } from "@microsoft/signalr";

const google: any = null;

export const FETCH_TASKS_STATUSES = "FETCH_TASKS_STATUSES";
export const FETCH_TASKS_STATUS = "FETCH_TASKS_STATUS";
export const ADD_TASK_STATUS = "ADD_TASK_STATUS";
export const UPDATE_TASK_STATUS = "UPDATE_TASK_STATUS";
export const DELETE_TASK_STATUS = "DELETE_TASK_STATUS";
export const CLEAR_TASK_STATUS = "CLEAR_TASK_STATUS";
export const CLEAR_TASK_STATUS_REDIRECT = "CLEAR_TASK_STATUS_REDIRECT";


export function fetchTaskStatuses(filmId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_TASKS_STATUSES,
      payload: getApiClient().get(`/film/${filmId}/taskStatus`)
    });
  };
}

export function fetchTaskStatus(filmId, taskStatusId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_TASKS_STATUS,
      payload: getApiClient().get(`/film/${filmId}/taskStatus/${taskStatusId}`)
    });
  };
}

export function deleteTaskStatus(filmId, id) {
  return (dispatch) => {
    dispatch({
      type: DELETE_TASK_STATUS,
      payload: getApiClient().delete(`/film/${filmId}/taskStatus/${id}`),
      meta: { id }
    });
  };
}

export function addTaskStatus(filmId, taskStatus) {
  return (dispatch) => {

    dispatch({
      type: ADD_TASK_STATUS,
      payload: getApiClient().post(`/film/${filmId}/taskStatus`, taskStatus),
      meta: { taskStatusId: taskStatus.id }
    });
  };
}

export function updateTaskStatus(filmId, id, taskStatus) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_TASK_STATUS,
      payload: getApiClient().put(`/film/${filmId}/taskStatus/${id}`, taskStatus),
      meta: { id, taskStatus }
    });
  };
}

export function clearTaskStatus() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_TASK_STATUS
    });
  };
}

export function clearRedirect() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_TASK_STATUS_REDIRECT
    });
  };
}

